module.exports = __webpack_public_path__ + "images/chevron-nav-icon-59e04160.svg";